import { render, staticRenderFns } from "./BaseCheckBoxList.vue?vue&type=template&id=4c463ca8&scoped=true&lang=pug&"
import script from "./BaseCheckBoxList.vue?vue&type=script&lang=js&"
export * from "./BaseCheckBoxList.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckBoxList.vue?vue&type=style&index=0&id=4c463ca8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c463ca8",
  null
  
)

export default component.exports